import { ResponseDataTest } from "../../../models/responseDataTest";
import { EntRole } from "../../../models/role";
import { agroApi } from "../api";
import { EntInitialFilterName } from "../../../models/filters/initialFilterName";
import { EntRoleAvailableRoutesResponse } from "../../../models/rolesAvailableRoutes";
import { Paths } from "../../../paths";

export const rolesApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getRolesList: builder.query<ResponseDataTest<EntRole[]>, EntInitialFilterName>({
	  query: (filter) => ({
		url: `${Paths.roles}/get-all`,
		method: "POST",
		body: JSON.stringify(filter)
	  }),
	}),
	getRolesById: builder.query<ResponseDataTest<EntRole>, number>({
	  query: (id) => ({
		url: `${Paths.roles}/${ id }`,
		method: 'GET'
	  })
	}),
	addRole: builder.mutation<ResponseDataTest<EntRole>, EntRole>({
	  query: (body) => ({
		url: `${Paths.roles}`,
		method: "POST",
		body: JSON.stringify(body)
	  }),
	}),
	editRole: builder.mutation<ResponseDataTest<EntRole>, EntRole>({
	  query: (body,) => ({
		url: `${Paths.roles}`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),
	deleteRole: builder.mutation<ResponseDataTest<EntRole>, number>({
	  query: (id) => ({
		url: `${Paths.roles}/${ id }`,
		method: 'DELETE',
	  }),
	}),
	getRolesAllRoutes: builder.query<ResponseDataTest<EntRoleAvailableRoutesResponse>, string | void>({
	  query: (description) => ({
		url: `${Paths.roles}/get-all-routes`,
		method: 'GET',
		params: description ? { description } : {}, // Передаем параметр в запрос
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useLazyGetRolesListQuery,
  useAddRoleMutation,
  useEditRoleMutation,
  useDeleteRoleMutation,
  useGetRolesAllRoutesQuery,
  useLazyGetRolesAllRoutesQuery
} = rolesApi;
